import { memo } from 'react';
import { Check } from 'lucide-react';
import SuffixeRenderer from '../SuffixeRenderer';

/**
 * Rendu preview/élève d'une question texte libre (saisie).
 * Affiche un champ de saisie grisé + la réponse attendue.
 *
 * @param {string} bonneReponse - La réponse attendue
 * @param {boolean} strict - Mode strict ou tolérant
 * @param {string} suffixe - Unité affichée après le champ (optionnel, supporte KaTeX)
 * @param {boolean} light - Theme clair (fond blanc)
 */
const TexteLibreRenderer = memo(function TexteLibreRenderer({ bonneReponse, strict, suffixe, light }) {
    return (
        <div>
            <span className={`text-[10px] font-semibold uppercase tracking-wider mb-2 block ${light ? 'text-gray-400' : 'text-slate-400'}`}>Réponse</span>

            {/* Champ de saisie simulé + suffixe */}
            <div className="flex items-center gap-2">
                <div className={`flex-1 px-3 py-2.5 rounded-xl border text-sm italic ${
                    light ? 'border-gray-200 bg-gray-50 text-gray-400' : 'border-slate-600 bg-slate-700/50 text-slate-500'
                }`}>
                    Saisir la réponse...
                </div>
                <SuffixeRenderer suffixe={suffixe} className={`text-sm font-semibold flex-shrink-0 ${light ? 'text-gray-600' : 'text-slate-300'}`} />
            </div>

            {/* Réponse attendue */}
            <div className={`mt-3 flex items-center gap-2 px-3 py-2.5 rounded-xl border ${
                light ? 'border-emerald-300 bg-emerald-50' : 'border-emerald-500/50 bg-emerald-500/10'
            }`}>
                <span className="w-7 h-7 rounded-lg bg-emerald-500 text-white flex items-center justify-center flex-shrink-0">
                    <Check size={14} strokeWidth={3} />
                </span>
                <span className={`text-sm font-medium flex items-center gap-1 ${light ? 'text-emerald-700' : 'text-emerald-200'}`}>
                    {bonneReponse}
                    <SuffixeRenderer suffixe={suffixe} className={light ? 'text-emerald-500' : 'text-emerald-300/70'} />
                </span>
                <span className={`ml-auto text-[10px] ${light ? 'text-gray-400' : 'text-slate-400'}`}>
                    {strict ? 'Strict' : 'Tolérant'}
                </span>
            </div>
        </div>
    );
});

export default TexteLibreRenderer;
